/*
 *  A central WebSocket handler that creates the Websocket, and 
 *  listens for messages. Should the connection close, it will
 *  re-attempt to make a connection
 * 
 *  When messages are received, the appropriate "process" function
 *  will be called to handle the payload.
 * 
 *  Currently set up for:
 *      What's On Now
 *      Schedule Page
 *      YouTube Live Broadcasts
 */

import { parseURL } from './utils'
import { loadVideo } from './youtube-live';

function WFMTWebSocket() {
  let ws

  async function websocket(url) {
    ws = new WebSocket(url)

    if (!ws) {
      throw new Error("server didn't accept ws")
    }

    ws.addEventListener("open", () => {

      if (window.WFMT_WS && window.WFMT_WS.secret) {
        console.log("[WS] Auth secret found, sending auth message…");

        ws.send(JSON.stringify({
          type: "auth",
          secret: window.WFMT_WS.secret
        }));

        console.log("[WS] Auth message sent");
      } else {
        console.warn("[WS] No auth secret found! Connection will fail.");
      }

      ws.send("won");
      ws.send("schedule");
      ws.send("youtube");
    });

    ws.addEventListener("message", (payload) => {
      var data = JSON.parse(payload.data);
      if (data.won) {
        processWON(data.won);
      }
      if (data.schedule) {
        processSchedule(data.schedule);
      }
      if (data.youtube) {
        processYouTube(data.youtube);
      }
    })

    ws.addEventListener("error", (event) => {
      console.log("WebSocket error: ", event);
    });

    ws.addEventListener("close", (event) => {
      // console.log('Closed websocket: ' + event.reason);
      setTimeout(function() {
        WFMTWebSocket();
      }, 10000);
    })
  }

  //const url = new URL("ws://localhost:8787/ws");
  const url = new URL("https://won.wfmt.com/ws");
  websocket(url);

  const processWON = (data) => {
    if (data) {
      var wonHTML = processWONJSON(data);
      if (wonHTML) {
        if (wonHTML.won2) {
          jQuery('div#wfmt-won-2').html(wonHTML.won2);
        }
        if (wonHTML.won3) {
          jQuery('div#wfmt-won-3').html(wonHTML.won3);
        }
      }

      // Trigger an event so that any other components, like the LiveStream player, can refresh themselves
      const eventWONUpdate = new CustomEvent("wonUpdate", {
        bubbles: true,
        detail: data,
      });
      window.dispatchEvent(eventWONUpdate);          
    }
  }

  const processSchedule = (data) => {
    if ((data) && (window.location.href.includes('schedule'))) {
      var onCurrentDay = true;
      if (window.location.href.includes('pldate')) {
        const urlParams = new URLSearchParams(window.location.search);
        const pldate = urlParams.get('pldate');
        // Get Chicago date, just in case visitor is somewhere else
        const ChicagoDate = new Intl.DateTimeFormat("en-US", {
          year: "numeric", 
          month: "2-digit", 
          day: "2-digit",
          timeZone: "America/Chicago"
        }).format(Date.now());
        if (pldate !== ChicagoDate) {
          onCurrentDay = false;
        }
      }

      if (onCurrentDay) {
        const currentHour = data.currentHour;
        const text = data.text;

        // Update the "what's on now" anchor with the currentHour
        var anchor = document.querySelector("#hour-navigation a");
        if (anchor && currentHour) {
          if (anchor.hash !== "#" + currentHour) {
            anchor.hash = "#" + currentHour;
            if (anchor.getAttribute('wfmt-anchor-to')) {
              anchor.setAttribute('wfmt-anchor-to', "#" + currentHour);
            }
            anchor.href = "#" + currentHour;
            anchor.classList.remove('anchor-link-other-page');
          }
          if (anchor.getAttribute('target')) {
            anchor.removeAttribute('target');
          }
        }

        if (text) {
          // console.log("updating playlist with new HTML");
          var newHTML = jQuery(text.replace("↵", ""));
          var playListMain = jQuery('#playlist-main', newHTML).html();
          jQuery('#playlist-main').html(playListMain);
        }      
      }
    }
  }

  const processYouTube = (videoInfo) => {
    if (videoInfo && videoInfo.info && videoInfo.info.items.length > 0){
      loadVideo(videoInfo.info.items[0]);
    }
  }

  return ws;
}

function processWONJSON(jsonResult) {
  var won2 = `<h4 class="h-widget">What’s Playing Now</h4>`;
  var won3 = '';

  if (jsonResult['show'] && jsonResult['show']['title']) {

    won2 += `<h3 class="showtitle mtn">`;
    won3 += '<h5 class="now-playing mvn">';
    if (jsonResult['show']['main_link']) {

      won2 += `<a href="` + parseURL(jsonResult['show']['main_link']).pathname + `" 
                    class="internal-link">`;

      won3 += `<a href="` + parseURL(jsonResult['show']['main_link']).pathname + `" class="showtitle"
                    data-cturl="` + parseURL(jsonResult['show']['main_link']).pathname + `">`;
    }

    won2 += jsonResult['show']['title']
    won3 += jsonResult['show']['title']

    if (jsonResult['show']['main_link']) {
      won2 += `</a>`;
      won3 += `</a>`;
    }

    won2 += `</h3>`;
    won3 += `</h5>`;
  }
  if ('track' in jsonResult && jsonResult['track'] != null) {

    var Composer = jsonResult['track']['composer'] || '';
    var Title = jsonResult['track']['title'] || '';
    var Orchestra = jsonResult['track']['orchestra'] || '';
    var Title = jsonResult['track']['title'] || '';
    var Soloists = jsonResult['track']['soloists'] ? jsonResult['track']['soloists'].join(" | ") : '';

    if (Title) {
      won2 += `<p class="now-playing stacked"><strong>` +
        Title + `</strong><br>`
      won3 += '<p class="now-playing horiz"><strong>' + Title + '</strong>';
    }
    if (Orchestra) {
      won2 += `<span class="divider"> | </span>` + Orchestra;
      won3 += ' | ' + Orchestra;
    }
    if (Composer) {
      won2 += `<span class="divider"> | </span>` + Composer;
      won3 += ' | ' + Composer;
    }
    if (Soloists) {
      won2 += `<span class="divider"> | </span>` + Soloists;
      won3 += ' | ' + Soloists;
    }
    won2 += '</p>';
    won3 += '</p>';
  }

  return {
    "won2": won2,
    "won3": won3
  };
}



export {
  WFMTWebSocket
};